module.exports = __webpack_public_path__ + "img/toplogo.7120a4a3.png";